import { createFileRoute } from '@tanstack/react-router'
import IntegracoesPage from '@/pages/dashboard/integracoes-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/',
)({
  component: IntegracoesPage,
})
